// ----------------------------------------------------------------------
// SEARCH

export const SearchPaths = {
  ROOT: '/search',

  ORDER_PREVIEW: 'order-preview',
} as const;

// ----------------------------------------------------------------------
// ORDERS

export const OrdersPaths = {
  ROOT: '/orders',
  VIEW: '/orders/:orderGuid',
  RECONCILIATION_FIELD_MATCHING: '/orders/reconciliation/field-matching',
  RECONCILIATION_BINDING: '/orders/reconciliation/binding',
  RECONCILIATION_RESULT: '/orders/reconciliation/result/:orderGuid',
} as const;

// ----------------------------------------------------------------------
// PRICE-LISTS

export const PriceListsPaths = {
  ROOT: '/price-lists',
} as const;

// ----------------------------------------------------------------------
// SPECIAL-PRICE-LISTS

export const SpecialPriceListsPaths = {
  ROOT: '/special-price-lists',
} as const;

// ----------------------------------------------------------------------
// CREATE-TELEGRAM-GROUP

export const CreateTelegramGroupPaths = {
  ROOT: '/create-telegram-group',
} as const;
